import axiosInstance from './axiosConfig';

export const TASK_PRIORITIES = [
  { id: 'high', label: 'High', color: '#ef4444' },
  { id: 'medium', label: 'Medium', color: '#f59e0b' },
  { id: 'low', label: 'Low', color: '#10b981' },
];

export const TASK_STATUSES = [
  { id: 'todo', label: 'To do', icon: '○' },
  { id: 'in-progress', label: 'In progress', icon: '◐' },
  { id: 'blocked', label: 'Blocked', icon: '⊘' },
  { id: 'done', label: 'Done', icon: '●' },
];

export const TASK_RECURRENCES = [
  { id: 'none', label: 'Does not repeat' },
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'yearly', label: 'Yearly' },
];

/** Client for the ATOZAS Tasks backend (/api/tasks/*). */
export const tasksApi = {
  list: (params = {}) => axiosInstance.get('/api/tasks', { params }).then((r) => r.data),
  categories: () => axiosInstance.get('/api/tasks/categories').then((r) => r.data),
  dueReminders: () => axiosInstance.get('/api/tasks/reminders').then((r) => r.data),
  create: (payload) => axiosInstance.post('/api/tasks', payload).then((r) => r.data),
  /** Turn an email into a task, keeping a link back to the message. */
  createFromMail: (mailId, overrides = {}) =>
    axiosInstance.post('/api/tasks/from-mail', { mailId, ...overrides }).then((r) => r.data),
  update: (id, payload) => axiosInstance.put(`/api/tasks/${id}`, payload).then((r) => r.data),
  remove: (id) => axiosInstance.delete(`/api/tasks/${id}`).then((r) => r.data),
  clearCompleted: () => axiosInstance.delete('/api/tasks/completed').then((r) => r.data),
  reorder: (orderedIds) =>
    axiosInstance.patch('/api/tasks/reorder', { orderedIds }).then((r) => r.data),
};

export default tasksApi;
